<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/products'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
  />
</template>
<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { SplitViewService } from "../../../_services/api/templates/split-view.services";
import { ProductService } from "../../../_services/api/products/product.service";

export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        Code: "",
        Description: "",
        Wastage: 0,
        SalesGLChartCode: null,
        CostGLChartCode: null,
        StockGLChartCode: null,
        PurchaseGLChartCode: null,
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        IsDefault: "Y",
        IsDefaultData: false,
        SetDefault: true,
        Inactive: true,
      },
      data: {
        title: "Product Category 2",
        pageRoute: "/product-category-2",
        saveEndPoint: "Save_ProductCategory2",
        recordEndPoint: "ProductCategory2",
        isDefaultEndPoint: "Save_DefaultProductCategory2",
        exportFileName: "Product Category 2",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ProductCategory2List",
              filter: "",
              // select: ["Code", "Description", "Inactive", "IsDefault"],
              select: [
                "Code",
                "Description",
                "Wastage",
                "SalesGLChartCode",
                "CostGLChartCode",
                "StockGLChartCode",
                "PurchaseGLChartCode",
                "Inactive",
                "SalesGLChartDescription",
                "CostGLChartDescription",
                "StockGLChartDescription",
                "PurchaseGLChartDescription",
                "IsDefault",
              ],
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "product-category-2",
              mode: "review",
              idProperty: "Code",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/product-category-2/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "ProductCategory2",
              gridDataField: "Description",
              allowSearch: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "Code",
                  label: "Product Category 2 Code",
                },
                {
                  dataField: "Description",
                  label: "Product Category 2 Description",
                },
              ],
              allowHiding: false,
              label: "Category 2",
            },

            {
              screenField: "ProductCategory2",
              gridDataField: "SalesGLChartDescription",
              allowSearch: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SalesGLChartDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "SalesGLChartCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "SalesGLChartCode",
                  label: "Sales Account Code",
                },
                {
                  dataField: "SalesGLChartDescription",
                  label: "Sales Account Description",
                },
              ],
              allowHiding: false,
              label: "Sales Account",
            },

            {
              screenField: "ProductCategory2",
              gridDataField: "PurchaseGLChartDescription",
              allowSearch: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "PurchaseGLChartDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "PurchaseGLChartCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "PurchaseGLChartCode",
                  label: "Purchase Account Code",
                },
                {
                  dataField: "PurchaseGLChartDescription",
                  label: "Purchase Account Description",
                },
              ],

              allowHiding: false,
              label: "Purchase Account",
            },

            {
              screenField: "ProductCategory2",
              gridDataField: "CostGLChartDescription",
              allowSearch: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "CostGLChartDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "CostGLChartCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "CostGLChartCode",
                  label: "Stock Movt Account Code",
                },
                {
                  dataField: "CostGLChartDescription",
                  label: "Stock Movt Account Description",
                },
              ],
              allowHiding: false,
              label: "Stock Movt Account",
            },

            {
              screenField: "ProductCategory2",
              gridDataField: "StockGLChartDescription",
              allowSearch: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "StockGLChartDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "StockGLChartCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "StockGLChartCode",
                  label: "SOH Account Code",
                },
                {
                  dataField: "StockGLChartDescription",
                  label: "SOH Account Description",
                },
              ],
              allowHiding: false,
              label: "SOH Account",
            },

            {
              screenField: "IsDefault",
              makeDisabled: (data) => {
                return (
                  data.column.dataField == "IsDefault" &&
                  data.data.Inactive == "Y"
                );
              },
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: "0",
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "IsDefault",
              listner: async (event, cellInfo, grid, updateIsDefault) => {
                var items = grid.getDataSource().items();
                var getDefault,
                  clickedDefault = undefined;
                if (items)
                  items.forEach((element) => {
                    if (element.Code == cellInfo.data.Code)
                      clickedDefault = element.Code;
                    if (element.IsDefault == "Y") getDefault = element.Code;
                  });
                if (!getDefault)
                  await SplitViewService.getIsDefault("ProductCategory2").then(
                    (res) => {
                      if (res.data.value.length > 0)
                        getDefault = res.data.value[0].Code;
                    }
                  );
                let confirmLeaving = await this.$confirm(
                  `Do you want to change the default setting from ${getDefault} to ${clickedDefault} ?`,
                  "Default Setting Change"
                );
                if (!confirmLeaving) {
                  event.component.beginUpdate();
                  event.component.option("value", false);
                  event.component.endUpdate();
                  return;
                }
                if (updateIsDefault) {
                  this.$store.dispatch("ui/setUpdateIsDefault", {
                    update: true,
                    code: cellInfo.data.Code,
                    event: event,
                  });
                }
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    setDefaultEdit() {
      return this.formModel["IsDefaultData"] || !this.formModel["Inactive"];
    },
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
                onValueChanged: (e) => {
                  this.onActiveValueChanged(e);
                },
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                editorOptions: {
                  maxLength: 3,
                },
                // label:"Market",
                required: true,
                // allowUpdate: this.baseView.mode == "edit" ? false : true,
                screenField: "Code",
                isPrimaryKeyField: true,
                visible: this.baseView.mode == "create",
              },
              {
                screenField: "Code",
                dataField: "Description",
                label: { text: "Description" },
                visible: true,
                required:
                  this.baseView.mode == "edit" ||
                  this.baseView.mode == "create",
                allowUpdate:
                  this.baseView.mode == "edit" ||
                  this.baseView.mode == "create",
                editorOptions: {
                  maxLength: 30,
                },
              },
              {
                screenField: "Total",
                dataField: "Wastage",
                label: {
                  text: "Wastage",
                },
                format: "Decimal-4-2",
                validationRules: [
                  {
                    type: "required",
                    message: "Wastage is required",
                  },
                  {
                    type: "range",
                    message: "Wastage is not between 0 and 100",
                    min: 0,
                    max: 100,
                  },
                ],
              },
              {
                dataField: "SetDefault",
                editorOptions: {
                  readOnly: this.setDefaultEdit,
                },
                screenField: "IsDefault",
              },
            ],
          },
          {
            itemType: "group",
            caption: "Associated Accounts",
            items: [
              {
                screenField: "GLChart",
                dataField: "SalesGLChartCode",
                label: { text: "Sales Account" },
                cellTemplate: "SelectField",
                allowUpdate: true,
                valueExpr: "Code",
                displayExpr: "Description",
                required:
                  this.baseView.mode == "create" ||
                  this.baseView.mode == "edit",
              },
              {
                screenField: "GLChart",
                dataField: "CostGLChartCode",
                label: { text: "Stock Account" },
                cellTemplate: "SelectField",
                allowUpdate: true,
                valueExpr: "Code",
                displayExpr: "Description",
                required:
                  this.baseView.mode == "create" ||
                  this.baseView.mode == "edit",
              },
              {
                screenField: "GLChart",
                dataField: "StockGLChartCode",
                label: { text: "Stock On Hand" },
                cellTemplate: "SelectField",
                allowUpdate: true,
                valueExpr: "Code",
                displayExpr: "Description",
                required:
                  this.baseView.mode == "create" ||
                  this.baseView.mode == "edit",
              },
              {
                screenField: "GLChart",
                dataField: "PurchaseGLChartCode",
                label: { text: "Purchase Account" },
                cellTemplate: "SelectField",
                allowUpdate: true,
                valueExpr: "Code",
                displayExpr: "Description",
                required:
                  this.baseView.mode == "create" ||
                  this.baseView.mode == "edit",
              },
            ],
          },
        ],
      };

      return form;
    },
  },
  methods: {
    async onActiveValueChanged(e) {
      if (
        this.baseView.mode == "edit" &&
        e.value == false &&
        e.previousValue == true
      ) {
        this.setLoading = true;
        ProductService.getProductData(
          `ProductCategory2Code eq '${this.baseView.id}'`
        )
          .then((res) => {
            this.setLoading = false;

            if (res.data.value.length > 0) {
              this.formModel.Inactive = true;

              e.component.beginUpdate();
              e.component.option("value", true);
              e.component.endUpdate();

              this.validationSummary = [];
              this.validationSummary.push({
                message: `${this.baseView.id} is associated with product records. This may not be marked inactive until it is no longer associated with product records.`,
              });
              this.validationSummary.push({
                message: `Tip: To identify the associated product use the filters on the product list.`,
              });
            }
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });
      }
    },
  },
};
</script>
